import React from 'react'
import ReactDOM from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import { TooltipProvider } from '@/shared/ui/tooltip'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from '@/shared/ui/sonner'
import App from '@/app/App'
import './index.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { ThemeProvider } from '@/shared/contexts/ThemeContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <TooltipProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <Toaster />
        <Analytics />
      </TooltipProvider>
    </ThemeProvider>
  </React.StrictMode>
)

if (import.meta.env.PROD) {
  serviceWorkerRegistration.register()

  // service-worker.js calls skipWaiting() unconditionally, so a new version takes
  // control (`controllerchange`) without anyone asking - but the already-open tab is
  // still running the old JS until it reloads. Without this, installed PWAs can be
  // stuck on a stale build indefinitely since they're never "refreshed" by hand.
  let hasReloadedForUpdate = false
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (hasReloadedForUpdate) return
    hasReloadedForUpdate = true
    window.location.reload()
  })
}
